import useSWR from 'swr'
import {fetchSchoolLicenses} from '@frontrow/console/src/helpers/api-schools'
import {fromOpenApiLicenses, type LicenseT} from '@frontrow/console/src/entities/models/license'

const SCHOOL_LICENSES_SWR_KEY = 'school-licenses'

export function useSchoolLicenses(schoolId: number): {
  data: Array<LicenseT> | undefined
  error: Error | undefined
  isLoading: boolean
  mutate: () => Promise<Array<LicenseT> | undefined>
} {
  const {data, error, isLoading, mutate} = useSWR(
    [SCHOOL_LICENSES_SWR_KEY, schoolId],
    async ([_, id]) => {
      const response = await fetchSchoolLicenses(id)
      return fromOpenApiLicenses(response)
    }
  )

  return {data, error, isLoading, mutate}
}
